import { render, staticRenderFns } from "./showHagrHagm.vue?vue&type=template&id=90dddc0a"
import script from "./showHagrHagm.vue?vue&type=script&lang=js"
export * from "./showHagrHagm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports